<template>
  <div
    class="page-two-column"
    :class="{'is-open': isShowRightBlock && !isOneColumn, 'has-scroll': hasScroll, 'is-one-column': isOneColumn}"
    :data-qa="dataQa"
    :style="`--panel-width: ${panelWidth}px; --right-block-compact: ${isOneColumn ? '0px' : '44px'};`">
    <div class="page-two-column__left">
      <slot name="left">
        <div class="page-two-column__left-header">
          <slot name="header">
            <Breadcrumbs
              class="pa-0"
              :items="breadcrumbs"/>
            <slot
              name="header-actions"/>
          </slot>
        </div>
        <div class="page-two-column__left-content">
          <slot name="left-content"/>
        </div>
      </slot>
      <slot name="left-footer"/>
    </div>
    <div
      v-if="!isOneColumn"
      v-show="mini || (currentBlock && currentBlock.component)"
      id="seperator"/>
    <div
      v-if="!isOneColumn"
      class="page-two-column__right">
      <slot
        :change-item="changeItem"
        name="right"
        :open="isShowRightBlock">
        <div
          class="page-two-column__right-menu">
          <slot name="menu"/>
        </div>
        <div
          class="page-two-column__right-content"
          :class="{'is-full': !listItems || !listItems.length}">
          <slot
            name="rightContent"
            :open="isShowRightBlock"/>

          <div
            v-if="listItems && listItems.length"
            class="page-two-column__right-btns">
            <sBadge
              v-for="listItem in listItems"
              :key="listItem.component"
              color="red"
              :content="listItem.count"
              :data-qa="`${dataQa}-badge-${listItem.tabIcon}`"
              :dot="listItem.badge.dot"
              :inner-styles="listItem.badge.dot ? '' : 'padding: 2px; height: 14px; min-width: 14px;'"
              :offset-x="listItem.badge.offsetX"
              :offset-y="listItem.badge.offsetY"
              overlap
              :value="!!listItem.count">
              <TooltipedBtn
                class="page-two-column__right-item"
                :color="currentBlock && currentBlock.component === listItem.component ? 'var(--v-secondary__green_not_active-base)' : 'var(--text-color)'"
                :data-qa="`${dataQa}-btn-${listItem.tabIcon}`"
                :disabled="loading || listItem.disabled"
                :icon="listItem.tabIcon"
                icon_size="22px"
                :text="listItem.name"
                @click="changeItem(listItem.index)"/>
            </sBadge>
          </div>
        </div>
      </slot>
    </div>
  </div>
</template>
<script>
const Breadcrumbs = () => import('components/common/elements/Breadcrumbs.vue')
import TooltipedBtn from 'components/common/elements/TooltipedBtn.vue'

import displaySize from 'mixins/display-size'
import storageMixin from 'mixins/storageMixin.js'

export default {
  name: 'TemplateTwoColPage',
  mixins: [ displaySize, storageMixin ],
  data() {
    return {
      panelWidth: 356,
    }
  },
  methods: {
    checkPanelWidth(panelWidth) {
      if (panelWidth + 100 > window.innerWidth) {
        return window.innerWidth - 100
      }
      return panelWidth
    },
    onMouseMove(e) {
      const distanceFromRight = window.innerWidth - e.clientX
      if (distanceFromRight <= 356) {
        return
      }
      this.$_savePropToDBStorage(this.localStorageWidthKey, distanceFromRight)
      this.panelWidth = this.checkPanelWidth(distanceFromRight)
    },
    dragMouseDown() {
      document.onmousemove = this.onMouseMove
      document.onmouseup = () => { document.onmousemove = document.onmouseup = null }
    },
    async dragElement() {
      const element = document.getElementById('seperator')
      if (element) {
        element.onmousedown = this.dragMouseDown
      }
    },
    async changeItem(value, init) {
      const componentProps = this.listItems.find(i => i.index === value)
      const currentBlock = !init && this.currentBlock?.component === componentProps?.component ? {} : componentProps

      this.$emit('update:mini', !currentBlock?.component)
      await this.$_savePropToDBStorage(this.localStorageKey, JSON.stringify(currentBlock))
      this.$emit('update:currentBlock', currentBlock)

      await this.dragElement()
    },
  },
  computed: {
    isShowRightBlock() {
      return this.mini || (this.currentBlock && this.currentBlock.component)
    },
    localStorageWidthKey() {
      return `${this.localStorageKey}Width`
    },
    localStorageKey() {
      return `${this.dataQa}Navbar`
    },
  },
  mounted() {
    if (!this.breakpoint.smAndDown) {
      this.$_getPropFromDBStorage(this.localStorageWidthKey, 356)
        .then(async(result) => {
          this.panelWidth = this.checkPanelWidth(+result)
        })
    }
    this.$_getPropFromDBStorage(this.localStorageKey, {})
      .then(async (result) => {
        try {
          const newIndex = JSON.parse(result)?.index
          if (result && newIndex !== undefined) {
            await this.changeItem(newIndex, true)
          } else {
            this.$emit('update:currentBlock', {})
            this.$emit('update:mini', true)
          }
        } catch (_) {
          /* */
        }
      })
  },
  components: {
    Breadcrumbs,
    TooltipedBtn,
  },
  created() {},
  props: {
    listItems: Array,
    currentBlock: {
      type: Object,
      default: () => ({}),
    },
    mini: Boolean,
    dataQa: {
      type: String,
      default: 'page-two-col',
    },
    breadcrumbs: {
      type: Array,
      default: () => [],
    },
    loading: {
      type: Boolean,
      default: false,
    },
    isOneColumn: {
      type: Boolean,
      default: false,
    },
  },
}
</script>
<style scoped lang="scss">
$class: '.page-two-column';

#{$class} {
  width: 100%;
  height: 100%;
  //background-color: var(--v-main__light_green-base);
  //overflow: hidden;
  display: grid;
  grid-template-columns: 1fr 42px;
  transition: grid-template-columns 0.3s ease-in-out;
  &>*:first-child>* {
    //padding-right: 5px;
    min-width: calc(100% - var(--right-block-compact));
    max-width: calc(100vw - 55px);
    transition: min-width 0.3s ease-in-out;
  }
  &__left {
    max-width: 100vw;
    position: relative;
    justify-content: center;
    display: grid;
    grid-template-rows: auto 1fr auto;
    grid-template-columns: 1fr;
    &-header {
      padding-left: 30px;
      padding-right: 30px;
      position: sticky;
      top: 0;
      z-index: 10;
      background: var(--v-main__green-base);
      height: 44px;
      display: grid;
      grid-template-columns: auto auto;
      border-bottom: 1px solid var(--main__green_locked);
      &::after {
        content: "";
        border-bottom: 1px solid var(--main__green_locked);
        position: absolute;
        right: -17px;
        bottom: -1px;
        width: 18px;
        height: 2px;
      }
    }
  }
  &-content {
    //padding-left: 16px;
    padding-top: 8px;
    width: 100%;
  }
  &__right {
    z-index: 10;
    position: fixed;
    top: 0;
    right: 0;
    height: 100%;
    display: grid;
    align-items: center;
    justify-items: center;
    grid-template-columns: 1fr;
    grid-template-rows: var(--right-block-compact) 1fr;
    background-color: var(--v-main__light_green-base) !important;
    width: var(--right-block-compact);
    transition: width 0.3s ease-in-out;
    &-content {
      margin: 0 0 auto 0;
      height: 100%;
    }
    &-title {
      display: grid;
      grid-template-columns: 40px auto;
      &-label {
        font-size: 24px;
        font-weight: 600;
        line-height: 32px;
      }
    }
    &-menu {
      border-bottom: 1px solid var(--main__green_locked);
      height: 100%;
    }
    &-btns {
      padding-top: 10px;
      gap: 10px;
      display: grid;
      align-items: center;
      justify-items: center;
      grid-template-rows: repeat(auto-fill, 41px);
      height: 100%;
      border-left: 1px solid transparent;
    }
    &-item {
      cursor: pointer;
      transition: 0.25s all;
    }
    &-menu,
    &-content {
      display: grid;
      grid-template-columns: var(--right-block-compact);
      width: 100%;
    }
  }
}
#{$class}.is-open:not(.is-one-column) {
  grid-template-columns: calc(100% - 5px - var(--panel-width)) 5px var(--panel-width);
  transition: grid-template-columns 0.3s ease-in-out;
  &.has-scroll {
    grid-template-columns: calc(100% - 13px - var(--panel-width)) 5px var(--panel-width);
  }
  &>*:first-child>* {
    min-width: calc(100% - var(--panel-width));
    transition: min-width 0.3s ease-in-out;
  }
  #{$class}__right {
    width: var(--panel-width);
    transition: width 0.3s ease-in-out;
    &-menu,
    &-content {
      grid-template-columns: minmax(50px, 1fr) var(--right-block-compact);
      transition: grid-template-columns 0.3s ease-in-out;
      &.is-full {
        grid-template-columns: minmax(50px, 1fr);
      }
    }
    &-btns {
      border-left: 1px solid var(--main__green_locked);
    }
  }
}
#{$class}.is-one-column {
  grid-template-columns: 1fr;
}

#seperator {
  transition: all .2s cubic-bezier(.785,.135,.15,.86) .1s;
  width: 5px;
  height: 100%;
  cursor: col-resize;
  opacity: .2;
  user-select: none;
  border-right: 2px solid var(--v-main__light_green-base);
  border-left: 2px solid var(--v-main__light_green-base);
  background: var(--main__green_locked);
  &:focus,
  &:hover {
    opacity: 1;
    background-color: var(--main__green_locked);
  }
}
</style>